import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IActirisError, IUnSubscribeEvent } from '../../Models';
import { EventService } from '../../Services';

interface UnSubscribeEventWidgetProps {
    id: string;
    email: string;
    dictUnSubscribe: string;
    dictConfirm: string;
    dictErrorUnSubscribe: string;
    dictSuccessUnSubscribe: string;
}

interface UnSubscribeEventWidgetState {
    unSubscribe: IUnSubscribeEvent;
    subscribeSuccess: boolean;
    error: string;
}

export class UnSubscribeEventWidget extends Component<
    UnSubscribeEventWidgetProps,
    UnSubscribeEventWidgetState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            unSubscribe: {
                email: this.props.email,
                id: +this.props.id,
            },
            subscribeSuccess: false,
            error: '',
        };

        this.submitUnSubscribe = this.submitUnSubscribe.bind(this);
    }

    async submitUnSubscribe(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        try {
            const response: IActirisError = await EventService.unSubscribeEvent(
                this.state.unSubscribe
            );
            if (!response || (!response.code && !response.message)) {
                this.setState({ subscribeSuccess: true });
            } else {
                this.setState({ error: response.message });
            }
        } catch (e) {
            if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                throw e;
            }
        }
    }

    render() {
        let modalUnSubscribe: JSX.Element;
        if (this.state.subscribeSuccess) {
            modalUnSubscribe = (
                <>
                    <div
                        className="alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        {this.props.dictSuccessUnSubscribe}
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <i className="icon-cross"></i>
                        </button>
                    </div>
                </>
            );
        } else {
            modalUnSubscribe = (
                <>
                    {this.state.error && (
                        <div
                            className="alert alert-danger alert-dismissible fade show"
                            role="alert"
                        >
                            {this.props.dictErrorUnSubscribe}
                            <button
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <i className="icon-cross"></i>
                            </button>
                        </div>
                    )}
                    <p>{this.props.dictUnSubscribe}</p>
                    <button
                        className="form-submit"
                        type="submit"
                        onClick={(e) => {
                            void this.submitUnSubscribe(e);
                        }}
                    >
                        {this.props.dictConfirm}
                    </button>
                </>
            );
        }

        return <>{modalUnSubscribe}</>;
    }
}

WidgetHelper.register(UnSubscribeEventWidget, 'unsubscribe-event-form-widget');
